import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { calculateSum, getFirebaseDocs, randomString } from '../common'
import Header from '../components/Header'
import Tabs from "../components/Tabs";
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";
import { useCreateOrganizationMutation, useGetUserMutation, useKpiRatingsMutation, useNotifyUsersMutation, useOrgsMutation, useRefetchLinkedInOrgsMutation } from "../redux/apiReducer";
import { format, isSameMonth, subMonths } from "date-fns";
import Table from "../components/Table";
import ModalComponent from "../components/Modal";
import Checkbox from "../components/Checkbox";

const Companies = () => {

    const [loading, setLoading] = useState(false)
    const [serverError, setServerError] = useState('')
    const [companies, setCompanies] = useState([])
    const [showUsers, setShowUsers] = useState(false)
    const [showRawCompany, setShowRawCompany] = useState(false)

    const [addingOrg, setAddingOrg] = useState(false)

    const [chosenCompanies, setChosenCompanies] = useState([])

    const userInfo = useSelector(state => state.user.user)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [companyId, setCompanyId] = useState('')
    const [company, setCompany] = useState('')
    const [logo_url, setLogo_Url] = useState('')
    const [company_linkedin_profile_url, setCompany_linkedin_profile_url] = useState('')
    const [domain, setDomain] = useState('')

    const [refetchLinkedInCompanies, { data: companiesLinkedInRefetchData, error: companiesLinkedInRefetchError, isLoading: isLoadingRefetch }] = useRefetchLinkedInOrgsMutation()
    const [createOrganization, { data: createOrganizationData, error: createOrganizationError, isLoading: isLoadingCreateOrg, reset: resetCreateOrganization }] = useCreateOrganizationMutation()
    const [notifyUsers, { data: notifyUsersData, error: notifyUsersError, isLoading: isLoadingNotifyUsers, reset: resetNotifyUsers }] = useNotifyUsersMutation()
    const [fetchCompanies, { data: companiesData, error: companiesError }] = useOrgsMutation()

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                getUserInfo(uid)
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])



    useEffect(() => {
        if (serverError) {
            // Toast.show({ type: 'error', text1: 'Error', text2: serverError })
            setServerError('')
        }
    }, [serverError])

    useEffect(() => {
        if (companiesData) {
            // console.log('companiesData', companiesData)
            if (companiesData.err) {
                setServerError(companiesData.err)
                return
            }
            if (companiesData.data) {
                setCompanies(companiesData.data)
            }
        }
    }, [companiesData])


    useEffect(() => {
        if (companiesError) {
            console.error('companiesError', companiesError)
            if (companiesError.data && companiesError.data.err) {
                setServerError(companiesError.data.err)
            }
        }
    }, [companiesError])

    useEffect(() => {
        if (companiesLinkedInRefetchData) {
            // console.log('companiesLinkedInRefetchData', companiesLinkedInRefetchData)
            if (companiesLinkedInRefetchData.err) {
                setServerError(companiesLinkedInRefetchData.err)
                return
            }
            if (companiesLinkedInRefetchData.data) {
                fetchCompanies()
                toast.success('Refreshed companies')

            }
        }
    }, [companiesLinkedInRefetchData])


    useEffect(() => {
        if (companiesLinkedInRefetchError) {
            console.error('companiesLinkedInRefetchError', companiesLinkedInRefetchError)
            if (companiesLinkedInRefetchError.data && companiesLinkedInRefetchError.data.err) {
                setServerError(companiesLinkedInRefetchError.data.err)
            }
        }
    }, [companiesLinkedInRefetchError])


    useEffect(() => {
        if (createOrganizationData) {
            // console.log('createOrganizationData', createOrganizationData)
            if (createOrganizationData.err) {
                setServerError(createOrganizationData.err)
                return
            }
            if (createOrganizationData.data) {
                setAddingOrg(false)
                fetchCompanies()
                toast.success('Organization created')
            }
        }
    }, [createOrganizationData])


    useEffect(() => {
        if (createOrganizationError) {
            console.error('createOrganizationError', createOrganizationError)
            if (createOrganizationError.data && createOrganizationError.data.err) {
                setServerError(createOrganizationError.data.err)
            }
        }
    }, [createOrganizationError])

    useEffect(() => {
        if (notifyUsersData) {
            // console.log('notifyUsersData', notifyUsersData)
            if (notifyUsersData.err) {
                setServerError(notifyUsersData.err)
                return
            }
            if (notifyUsersData.data) {
                toast.success('Notified Users')
            }
        }
    }, [notifyUsersData])


    useEffect(() => {
        if (notifyUsersError) {
            console.error('notifyUsersError', notifyUsersError)
            if (notifyUsersError.data && notifyUsersError.data.err) {
                setServerError(notifyUsersError.data.err)
            }
        }
    }, [notifyUsersError])

    useEffect(() => {
        if (userInfo) {
            console.log(userInfo)
            fetchCompanies()
        }
    }, [userInfo])

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'staff-users', uid))).data()
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
        // fetchCategories()
    }

    const signOutUser = async () => {
        await auth.signOut();
    }


    const handleRegenerate = () => {

        let rows = []

        for (let row of chosenCompanies) {
            const matchingCompany = companies.find(r => r._id === row)
            rows.push({ company_linkedin_profile_url: matchingCompany.company_linkedin_profile_url })
        }

        refetchLinkedInCompanies({ rows })
    }

    const handleCreateOrg = () => {
        createOrganization({ companyId, logo_url, company, company_linkedin_profile_url, domain, })
    }

    const handleNotify = organization => {
        notifyUsers({ organization })
    }

    if (addingOrg) {
        return <div className="container">
            <Header />

            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', gap: '40px' }}>
                <button disabled={!company || (!companyId && !company_linkedin_profile_url) || isLoadingCreateOrg} style={{ marginBottom: '20px', padding: '10px', borderRadius: '6px' }} onClick={handleCreateOrg}>Add New</button>
                <button className="secondary" style={{ marginBottom: '20px', padding: '10px', borderRadius: '6px' }} onClick={() => { setAddingOrg(false) }}>Cancel</button>
            </div>

            <Input errors={[]} label={'Company Id'} value={companyId} setValue={setCompanyId} placeholder={'Provide ID or Company LinkedIn Url'} />
            <Input errors={[]} label={'Company LinkedIn Url'} value={company_linkedin_profile_url} setValue={setCompany_linkedin_profile_url} placeholder={'https://www.linkedin.com/company/15251103/'} />
            <Input errors={[]} label={'Name'} value={company} setValue={setCompany} placeholder={'sasd'} />
            <Input errors={[]} label={'Logo Url'} value={logo_url} setValue={setLogo_Url} placeholder={'https://storage.googleapis.com/thumbbs-au.appspot.com/Images/ecolc637b2mko9c0msecmld2ed1se0.jpg?GoogleAccessId=firebase-adminsdk-t1ra5%40thumbbs-au.iam.gserviceaccount.com&Expires=16446978000&Signature=cbPUBH%2BVQ5gIyzRARbQ0DfIib7%2BK%2F2uudlfGCIn79Iuv1PRTv4z4AMgui4XVL4Ns7IxQh6AQaeIdyP0RM8eCKrnPfyJWFGe9Ay%2Bo%2F30feYtGMR0TCnqQAPJUA65QIYHh2h3AYW7kV9vAQbnKXn7phwKDVQ94ujrs8xbZ3KVFz0iqcs%2B5hM3PWjVeEThFIrufxBpHf2QYId4h3zNNLyfrLEs%2BXULkrHXX00Qmk1Z2Gw1BeUv22XVpWAAtFLQpwG%2FYSUFeVPSm1TI4xzhu6bkSJ0fRcnw2jNggXHgZ1DsLDRfXiLyNOAiw49iF2ZpzZBbSBp1HGRfghFEUGypD3m2wtg%3D%3D'} />
            <Input errors={[]} label={'Domain'} value={domain} setValue={setDomain} placeholder={'http://www.mica.ac.in'} />

        </div>
    }

    return <div className="container">
        <Header />

        <ModalComponent showModal={!!showUsers} setShowModal={setShowUsers} >
            <div style={{ height: '400px' }}>
                {showUsers && showUsers.present && <>
                    <h2 style={{ margin: 0 }}>Present Users</h2>

                    <Table
                        headers={<thead>
                            <th>
                                Id
                            </th>
                            <th>
                                First Name
                            </th>
                            <th>
                                Last Name
                            </th>
                            <th>
                                Email
                            </th>
                            <th>
                                Profile Pic
                            </th>
                        </thead>}
                        rows={showUsers.present.map(r => <tr key={r.userId}>
                            <td>{r.userId}</td>
                            <td>{r.firstName}</td>
                            <td>{r.lastName}</td>
                            <td>{r.email}</td>
                            <td>{r.profilePic && <img src={r.profilePic} style={{ width: '40px', height: '40px' }} />}</td>
                        </tr>
                        )}
                    />
                </>}

                {showUsers && showUsers.past && <>
                    <h2 style={{ margin: 0 }}>Past Users</h2>
                    <Table
                        headers={<thead>
                            <th>
                                Id
                            </th>
                            <th>
                                First Name
                            </th>
                            <th>
                                Last Name
                            </th>
                            <th>
                                Email
                            </th>
                            <th>
                                Profile Pic
                            </th>
                        </thead>}
                        rows={showUsers.past.map(r => <tr key={r.userId}>
                            <td>{r.userId}</td>
                            <td>{r.firstName}</td>
                            <td>{r.lastName}</td>
                            <td>{r.email}</td>
                            <td>{r.profilePic && <img src={r.profilePic} style={{ width: '40px', height: '40px' }} />}</td>
                        </tr>
                        )}
                    />
                </>}
            </div>

        </ModalComponent>

        <ModalComponent showModal={!!showRawCompany} setShowModal={setShowRawCompany} >


            <h2 style={{ margin: 0 }}>Company Raw Data</h2>
            {showRawCompany && <>
                <div style={{ height: '400px' }}>
                    <pre>{JSON.stringify(showRawCompany, undefined, 2)}</pre>
                </div>
            </>}

        </ModalComponent>

        {
            chosenCompanies.length > 0 ? <button disabled={isLoadingRefetch} style={{ marginLeft: 'auto', marginBottom: '20px', padding: '10px', borderRadius: '6px' }} onClick={handleRegenerate}>Regenerate</button> :
                <button style={{ marginLeft: 'auto', marginBottom: '20px', padding: '10px', borderRadius: '6px' }} onClick={() => { setAddingOrg(true) }}>Add New</button>
        }
        <Table
            headers={<thead>
                <th>

                </th>
                <th>
                    Id
                </th>
                <th>
                    Org Name
                </th>
                <th>
                    Last Accessed
                </th>
                <th>
                    LinkedIn Url
                </th>
                <th>
                    LinkedIn Logo Url
                </th>
                <th>
                    Industry
                </th>
                <th>
                    Website
                </th>
                <th>
                    Total Users
                </th>
                <th>
                    Present Users
                </th>
                <th>
                    Verified Users
                </th>
                <th>
                    Past Users
                </th>
                <th>
                    Total KPI Ratings
                </th>
                <th>
                    Avg Ratings
                </th>
                <th>
                    Proxycurl Detailed Run
                </th>
                <th>
                    Affiliate Existing
                </th>
                <th>
                    Verification Requirement
                </th>
                <th>
                    Action
                </th>
            </thead>}



            rows={companies.map(row => <tr key={row.organization}>
                <td>{row._id && <Checkbox value={chosenCompanies.includes(row._id)} setValue={() => setChosenCompanies(chosenCompanies.includes(row._id) ? [...chosenCompanies.filter(r => r !== row._id)] : [...chosenCompanies, row._id])} label={''} />}</td>
                <td>{row._id}</td>
                <td className="hover" style={{ color: 'green' }} onClick={() => setShowRawCompany(row.companyRaw)}>{row.organization}</td>
                <td>{row.lastAccessed ? format(new Date(row.lastAccessed), 'yyyy/MM/dd') : ''}</td>
                <td>{row.company_linkedin_profile_url ? <a href={row.company_linkedin_profile_url} target="_blank">{row.company_linkedin_profile_url}</a> : ''}</td>
                <td>{row.logo_url ? <img src={row.logo_url} style={{ width: '40px', height: '40px' }} /> : '-'}</td>
                <td>{row.industry}</td>
                <td>{row.domain || row.website}</td>
                <td className="hover" style={{ color: 'green' }} onClick={() => setShowUsers({ present: row.usersPresentDetails, past: row.usersPastDetails })}>{row.pastUsers + row.presentUsers}</td>
                <td>{row.presentUsers}</td>
                <td>{[...row.usersPresentDetails, ...row.usersPastDetails].filter(r => r.verified).length}</td>
                <td>{row.pastUsers}</td>
                <td>{row.totalKpiRatings}</td>
                <td>{row.avgKpiRating}</td>
                <td>{(!row.domain && !row.company_size_on_linkedin) ? 'Not run' : 'Run'}</td>
                <td>{row.affiliated_companies ? (row.affiliated_companies.length > 0 ? 'Yes' : 'No') : '-'}</td>
                <td>{row.company_size_on_linkedin ? (row.company_size_on_linkedin >= 20 ? 'Yes' : (row.affiliated_companies && row.affiliated_companies.length > 0 ? 'Yes' : 'No')) : '-'}</td>
                <td>{row._id ? <button style={{ padding: '10px', marginTop: 0 }} onClick={() => { setAddingOrg(true); setCompany_linkedin_profile_url(row.company_linkedin_profile_url); setDomain(row.domain || row.website); setCompany(row.organization); setLogo_Url(row.logo_url) }}>Edit</button> :
                    <button disabled={isLoadingNotifyUsers} style={{ padding: '10px', marginTop: 0 }} onClick={() => handleNotify(row.organization)}>Notify</button>}</td>

            </tr>)}
        />

    </div >
}

export default Companies